// The API cache (axios-cache-interceptor, src/api.ts) writes an entry as
// {"state":"loading"} when a request starts and replaces it when the response
// lands. A page that is closed, reloaded or navigated away from mid-request
// never gets that far, so the "loading" entry stays in localStorage for good.
//
// Synergy QA 2026-10-21 (defect 3): 19 such keys across 9 grids, left by fast
// page-hopping. Those grids then listed 0 rows on every visit until the keys
// were removed by hand.
//
// When the page loads, no request is in flight yet, so every "loading" entry
// found under the cache's prefix is left over from an earlier page. They are
// removed before the first request reads them.

export const API_CACHE_PREFIX = "aeronet-api-cache:";

/** Removes every leftover "loading" entry under `prefix`. Returns the keys removed. */
export function clearStaleLoadingEntries(
  storage: Storage,
  prefix: string = API_CACHE_PREFIX
): string[] {
  const removed: string[] = [];
  try {
    for (let i = storage.length - 1; i >= 0; i--) {
      const key = storage.key(i);
      if (!key || !key.startsWith(prefix)) continue;
      let state: unknown;
      try {
        state = JSON.parse(storage.getItem(key) ?? "null")?.state;
      } catch {
        // An entry the cache can't read is no better than a stuck one.
        state = "loading";
      }
      if (state === "loading") {
        storage.removeItem(key);
        removed.push(key);
      }
    }
  } catch {
    // Storage blocked (private mode, quota): there is nothing to clear.
  }
  return removed;
}
